/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { MyConsumptionCostViewModel } from '../models/my-consumption-cost-view-model';
import { MyConsumptionHistoryViewModel } from '../models/my-consumption-history-view-model';
import { MyConsumptionHourlySpotPriceViewModel } from '../models/my-consumption-hourly-spot-price-view-model';
import { MyConsumptionPowerOfAttorneyStatusViewModel } from '../models/my-consumption-power-of-attorney-status-view-model';
import { MyConsumptionResolutionViewModel } from '../models/my-consumption-resolution-view-model';
import { MyConsumptionTemperatureViewModel } from '../models/my-consumption-temperature-view-model';
import { MyConsumptionViewModel } from '../models/my-consumption-view-model';

@Injectable({
  providedIn: 'root',
})
export class MyConsumptionElementService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation elementsMyConsumptionPremisesPremiseIdElectricityStartDateGet
   */
  static readonly ElementsMyConsumptionPremisesPremiseIdElectricityStartDateGetPath = '/elements/my-consumption/premises/{premiseId}/electricity-start-date';

  /**
   * Get electricity start date for a premise.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyConsumptionPremisesPremiseIdElectricityStartDateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyConsumptionPremisesPremiseIdElectricityStartDateGet$Response(params: {

    /**
     * The id of the premise
     */
    premiseId: string;

    /**
     * Optional parameter for fetching the start date for a specific resolution.
     */
    resolution?: string;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, MyConsumptionElementService.ElementsMyConsumptionPremisesPremiseIdElectricityStartDateGetPath, 'get');
    if (params) {
      rb.path('premiseId', params.premiseId, {});
      rb.query('resolution', params.resolution, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Get electricity start date for a premise.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyConsumptionPremisesPremiseIdElectricityStartDateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyConsumptionPremisesPremiseIdElectricityStartDateGet(params: {

    /**
     * The id of the premise
     */
    premiseId: string;

    /**
     * Optional parameter for fetching the start date for a specific resolution.
     */
    resolution?: string;
  }): Observable<number> {

    return this.elementsMyConsumptionPremisesPremiseIdElectricityStartDateGet$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation elementsMyConsumptionPremisesPremiseIdElectricityHistoryGet
   */
  static readonly ElementsMyConsumptionPremisesPremiseIdElectricityHistoryGetPath = '/elements/my-consumption/premises/{premiseId}/electricity-history';

  /**
   * Get electricity resolution history for a premise.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyConsumptionPremisesPremiseIdElectricityHistoryGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyConsumptionPremisesPremiseIdElectricityHistoryGet$Response(params: {

    /**
     * The id of the premise
     */
    premiseId: string;

    /**
     * Optional parameter for fetching the history for a specific resolution.
     */
    resolution?: string;
  }): Observable<StrictHttpResponse<MyConsumptionHistoryViewModel>> {

    const rb = new RequestBuilder(this.rootUrl, MyConsumptionElementService.ElementsMyConsumptionPremisesPremiseIdElectricityHistoryGetPath, 'get');
    if (params) {
      rb.path('premiseId', params.premiseId, {});
      rb.query('resolution', params.resolution, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MyConsumptionHistoryViewModel>;
      })
    );
  }

  /**
   * Get electricity resolution history for a premise.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyConsumptionPremisesPremiseIdElectricityHistoryGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyConsumptionPremisesPremiseIdElectricityHistoryGet(params: {

    /**
     * The id of the premise
     */
    premiseId: string;

    /**
     * Optional parameter for fetching the history for a specific resolution.
     */
    resolution?: string;
  }): Observable<MyConsumptionHistoryViewModel> {

    return this.elementsMyConsumptionPremisesPremiseIdElectricityHistoryGet$Response(params).pipe(
      map((r: StrictHttpResponse<MyConsumptionHistoryViewModel>) => r.body as MyConsumptionHistoryViewModel)
    );
  }

  /**
   * Path part for operation elementsMyConsumptionPremisesPremiseIdTradingFeeStartDateGet
   */
  static readonly ElementsMyConsumptionPremisesPremiseIdTradingFeeStartDateGetPath = '/elements/my-consumption/premises/{premiseId}/trading-fee-start-date';

  /**
   * Get trading fee start date for a premise.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyConsumptionPremisesPremiseIdTradingFeeStartDateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyConsumptionPremisesPremiseIdTradingFeeStartDateGet$Response(params: {

    /**
     * The id of the premise
     */
    premiseId: string;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, MyConsumptionElementService.ElementsMyConsumptionPremisesPremiseIdTradingFeeStartDateGetPath, 'get');
    if (params) {
      rb.path('premiseId', params.premiseId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Get trading fee start date for a premise.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyConsumptionPremisesPremiseIdTradingFeeStartDateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyConsumptionPremisesPremiseIdTradingFeeStartDateGet(params: {

    /**
     * The id of the premise
     */
    premiseId: string;
  }): Observable<number> {

    return this.elementsMyConsumptionPremisesPremiseIdTradingFeeStartDateGet$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation elementsMyConsumptionPremisesPremiseIdHeatStartDateGet
   */
  static readonly ElementsMyConsumptionPremisesPremiseIdHeatStartDateGetPath = '/elements/my-consumption/premises/{premiseId}/heat-start-date';

  /**
   * Get heat start date for a premise.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyConsumptionPremisesPremiseIdHeatStartDateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyConsumptionPremisesPremiseIdHeatStartDateGet$Response(params: {

    /**
     * The id of the premise
     */
    premiseId: string;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, MyConsumptionElementService.ElementsMyConsumptionPremisesPremiseIdHeatStartDateGetPath, 'get');
    if (params) {
      rb.path('premiseId', params.premiseId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Get heat start date for a premise.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyConsumptionPremisesPremiseIdHeatStartDateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyConsumptionPremisesPremiseIdHeatStartDateGet(params: {

    /**
     * The id of the premise
     */
    premiseId: string;
  }): Observable<number> {

    return this.elementsMyConsumptionPremisesPremiseIdHeatStartDateGet$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation elementsMyConsumptionPremisesPremiseIdIsConsumingElectricityGet
   */
  static readonly ElementsMyConsumptionPremisesPremiseIdIsConsumingElectricityGetPath = '/elements/my-consumption/premises/{premiseId}/is-consuming-electricity';

  /**
   * Get if the premise is consuming electricity or not (if not it is producing electricity).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyConsumptionPremisesPremiseIdIsConsumingElectricityGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyConsumptionPremisesPremiseIdIsConsumingElectricityGet$Response(params: {

    /**
     * The id of the premise
     */
    premiseId: string;
  }): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, MyConsumptionElementService.ElementsMyConsumptionPremisesPremiseIdIsConsumingElectricityGetPath, 'get');
    if (params) {
      rb.path('premiseId', params.premiseId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Get if the premise is consuming electricity or not (if not it is producing electricity).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyConsumptionPremisesPremiseIdIsConsumingElectricityGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyConsumptionPremisesPremiseIdIsConsumingElectricityGet(params: {

    /**
     * The id of the premise
     */
    premiseId: string;
  }): Observable<boolean> {

    return this.elementsMyConsumptionPremisesPremiseIdIsConsumingElectricityGet$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * Path part for operation elementsMyConsumptionPremisesPremiseIdGridOwnerGet
   */
  static readonly ElementsMyConsumptionPremisesPremiseIdGridOwnerGetPath = '/elements/my-consumption/premises/{premiseId}/grid-owner';

  /**
   * Get the grid owner of the specified premise.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyConsumptionPremisesPremiseIdGridOwnerGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyConsumptionPremisesPremiseIdGridOwnerGet$Response(params: {

    /**
     * The id of the premise
     */
    premiseId: string;
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, MyConsumptionElementService.ElementsMyConsumptionPremisesPremiseIdGridOwnerGetPath, 'get');
    if (params) {
      rb.path('premiseId', params.premiseId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * Get the grid owner of the specified premise.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyConsumptionPremisesPremiseIdGridOwnerGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyConsumptionPremisesPremiseIdGridOwnerGet(params: {

    /**
     * The id of the premise
     */
    premiseId: string;
  }): Observable<string> {

    return this.elementsMyConsumptionPremisesPremiseIdGridOwnerGet$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation elementsMyConsumptionPremisesPremiseIdEnergyAreaGet
   */
  static readonly ElementsMyConsumptionPremisesPremiseIdEnergyAreaGetPath = '/elements/my-consumption/premises/{premiseId}/energy-area';

  /**
   * Get energy area of the specified premise.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyConsumptionPremisesPremiseIdEnergyAreaGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyConsumptionPremisesPremiseIdEnergyAreaGet$Response(params: {

    /**
     * The id of the premise
     */
    premiseId: string;
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, MyConsumptionElementService.ElementsMyConsumptionPremisesPremiseIdEnergyAreaGetPath, 'get');
    if (params) {
      rb.path('premiseId', params.premiseId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * Get energy area of the specified premise.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyConsumptionPremisesPremiseIdEnergyAreaGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyConsumptionPremisesPremiseIdEnergyAreaGet(params: {

    /**
     * The id of the premise
     */
    premiseId: string;
  }): Observable<string> {

    return this.elementsMyConsumptionPremisesPremiseIdEnergyAreaGet$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation elementsMyConsumptionPremisesPremiseIdResolutionsGet
   */
  static readonly ElementsMyConsumptionPremisesPremiseIdResolutionsGetPath = '/elements/my-consumption/premises/{premiseId}/resolutions';

  /**
   * Get available resolutions for a premise.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyConsumptionPremisesPremiseIdResolutionsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyConsumptionPremisesPremiseIdResolutionsGet$Response(params: {

    /**
     * The id of the premise
     */
    premiseId: string;
  }): Observable<StrictHttpResponse<MyConsumptionResolutionViewModel>> {

    const rb = new RequestBuilder(this.rootUrl, MyConsumptionElementService.ElementsMyConsumptionPremisesPremiseIdResolutionsGetPath, 'get');
    if (params) {
      rb.path('premiseId', params.premiseId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MyConsumptionResolutionViewModel>;
      })
    );
  }

  /**
   * Get available resolutions for a premise.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyConsumptionPremisesPremiseIdResolutionsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyConsumptionPremisesPremiseIdResolutionsGet(params: {

    /**
     * The id of the premise
     */
    premiseId: string;
  }): Observable<MyConsumptionResolutionViewModel> {

    return this.elementsMyConsumptionPremisesPremiseIdResolutionsGet$Response(params).pipe(
      map((r: StrictHttpResponse<MyConsumptionResolutionViewModel>) => r.body as MyConsumptionResolutionViewModel)
    );
  }

  /**
   * Path part for operation elementsMyConsumptionPremisesPremiseIdConsumptionGet
   */
  static readonly ElementsMyConsumptionPremisesPremiseIdConsumptionGetPath = '/elements/my-consumption/premises/{premiseId}/consumption';

  /**
   * Get electricity consumption for a premise for a given resolution and consumption type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyConsumptionPremisesPremiseIdConsumptionGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyConsumptionPremisesPremiseIdConsumptionGet$Response(params: {

    /**
     * The id of the premise
     */
    premiseId: string;

    /**
     * From date expressed in swedish short date string (yyyy-mm-dd).
     */
    fromDate?: string;

    /**
     * To date expressed in swedish short date string (yyyy-mm-dd).
     */
    toDate?: string;

    /**
     * The resolution of the consumption (Yearly, Monthly, Weekly, Daily or Hourly). If consumption type is &quot;Invoiced&quot; only Yearly and Monthly is valid.
     */
    resolution?: string;
  }): Observable<StrictHttpResponse<Array<MyConsumptionViewModel>>> {

    const rb = new RequestBuilder(this.rootUrl, MyConsumptionElementService.ElementsMyConsumptionPremisesPremiseIdConsumptionGetPath, 'get');
    if (params) {
      rb.path('premiseId', params.premiseId, {});
      rb.query('fromDate', params.fromDate, {});
      rb.query('toDate', params.toDate, {});
      rb.query('resolution', params.resolution, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<MyConsumptionViewModel>>;
      })
    );
  }

  /**
   * Get electricity consumption for a premise for a given resolution and consumption type.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyConsumptionPremisesPremiseIdConsumptionGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyConsumptionPremisesPremiseIdConsumptionGet(params: {

    /**
     * The id of the premise
     */
    premiseId: string;

    /**
     * From date expressed in swedish short date string (yyyy-mm-dd).
     */
    fromDate?: string;

    /**
     * To date expressed in swedish short date string (yyyy-mm-dd).
     */
    toDate?: string;

    /**
     * The resolution of the consumption (Yearly, Monthly, Weekly, Daily or Hourly). If consumption type is &quot;Invoiced&quot; only Yearly and Monthly is valid.
     */
    resolution?: string;
  }): Observable<Array<MyConsumptionViewModel>> {

    return this.elementsMyConsumptionPremisesPremiseIdConsumptionGet$Response(params).pipe(
      map((r: StrictHttpResponse<Array<MyConsumptionViewModel>>) => r.body as Array<MyConsumptionViewModel>)
    );
  }

  /**
   * Path part for operation elementsMyConsumptionPremisesPremiseIdHeatConsumptionGet
   */
  static readonly ElementsMyConsumptionPremisesPremiseIdHeatConsumptionGetPath = '/elements/my-consumption/premises/{premiseId}/heat-consumption';

  /**
   * Get heat consumption for a premise for a given resolution and consumption type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyConsumptionPremisesPremiseIdHeatConsumptionGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyConsumptionPremisesPremiseIdHeatConsumptionGet$Response(params: {

    /**
     * The id of the premise
     */
    premiseId: string;

    /**
     * From date expressed in swedish short date string (yyyy-mm-dd).
     */
    fromDate?: string;

    /**
     * To date expressed in swedish short date string (yyyy-mm-dd).
     */
    toDate?: string;

    /**
     * The resolution of the consumption (Monthly, Daily or Hourly).
     *             If consumption type is &quot;Cost&quot; only Monthly is valid.
     *             If consumption type is &quot;DeltaT&quot; only Monthly and Daily is valid.
     */
    resolution?: string;

    /**
     * The type of consumption (Energy, Flow, Cost, DeltaT)
     */
    consumptionType?: string;
  }): Observable<StrictHttpResponse<Array<MyConsumptionViewModel>>> {

    const rb = new RequestBuilder(this.rootUrl, MyConsumptionElementService.ElementsMyConsumptionPremisesPremiseIdHeatConsumptionGetPath, 'get');
    if (params) {
      rb.path('premiseId', params.premiseId, {});
      rb.query('fromDate', params.fromDate, {});
      rb.query('toDate', params.toDate, {});
      rb.query('resolution', params.resolution, {});
      rb.query('consumptionType', params.consumptionType, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<MyConsumptionViewModel>>;
      })
    );
  }

  /**
   * Get heat consumption for a premise for a given resolution and consumption type.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyConsumptionPremisesPremiseIdHeatConsumptionGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyConsumptionPremisesPremiseIdHeatConsumptionGet(params: {

    /**
     * The id of the premise
     */
    premiseId: string;

    /**
     * From date expressed in swedish short date string (yyyy-mm-dd).
     */
    fromDate?: string;

    /**
     * To date expressed in swedish short date string (yyyy-mm-dd).
     */
    toDate?: string;

    /**
     * The resolution of the consumption (Monthly, Daily or Hourly).
     *             If consumption type is &quot;Cost&quot; only Monthly is valid.
     *             If consumption type is &quot;DeltaT&quot; only Monthly and Daily is valid.
     */
    resolution?: string;

    /**
     * The type of consumption (Energy, Flow, Cost, DeltaT)
     */
    consumptionType?: string;
  }): Observable<Array<MyConsumptionViewModel>> {

    return this.elementsMyConsumptionPremisesPremiseIdHeatConsumptionGet$Response(params).pipe(
      map((r: StrictHttpResponse<Array<MyConsumptionViewModel>>) => r.body as Array<MyConsumptionViewModel>)
    );
  }

  /**
   * Path part for operation elementsMyConsumptionPremisesPremiseIdHourlySpotPricesGet
   */
  static readonly ElementsMyConsumptionPremisesPremiseIdHourlySpotPricesGetPath = '/elements/my-consumption/premises/{premiseId}/hourly-spot-prices';

  /**
   * Get hourly spot prices for energy area where premise is located.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyConsumptionPremisesPremiseIdHourlySpotPricesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyConsumptionPremisesPremiseIdHourlySpotPricesGet$Response(params: {

    /**
     * The id of the premise
     */
    premiseId: string;

    /**
     * From date expressed in swedish short date string (yyyy-mm-dd).
     */
    fromDate?: string;

    /**
     * To date expressed in swedish short date string (yyyy-mm-dd).
     */
    toDate?: string;
  }): Observable<StrictHttpResponse<Array<MyConsumptionHourlySpotPriceViewModel>>> {

    const rb = new RequestBuilder(this.rootUrl, MyConsumptionElementService.ElementsMyConsumptionPremisesPremiseIdHourlySpotPricesGetPath, 'get');
    if (params) {
      rb.path('premiseId', params.premiseId, {});
      rb.query('fromDate', params.fromDate, {});
      rb.query('toDate', params.toDate, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<MyConsumptionHourlySpotPriceViewModel>>;
      })
    );
  }

  /**
   * Get hourly spot prices for energy area where premise is located.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyConsumptionPremisesPremiseIdHourlySpotPricesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyConsumptionPremisesPremiseIdHourlySpotPricesGet(params: {

    /**
     * The id of the premise
     */
    premiseId: string;

    /**
     * From date expressed in swedish short date string (yyyy-mm-dd).
     */
    fromDate?: string;

    /**
     * To date expressed in swedish short date string (yyyy-mm-dd).
     */
    toDate?: string;
  }): Observable<Array<MyConsumptionHourlySpotPriceViewModel>> {

    return this.elementsMyConsumptionPremisesPremiseIdHourlySpotPricesGet$Response(params).pipe(
      map((r: StrictHttpResponse<Array<MyConsumptionHourlySpotPriceViewModel>>) => r.body as Array<MyConsumptionHourlySpotPriceViewModel>)
    );
  }

  /**
   * Path part for operation elementsMyConsumptionPremisesPremiseIdCustomerSpecificHourlySpotPricesGet
   */
  static readonly ElementsMyConsumptionPremisesPremiseIdCustomerSpecificHourlySpotPricesGetPath = '/elements/my-consumption/premises/{premiseId}/customer-specific-hourly-spot-prices';

  /**
   * Get customer specific hourly spot prices for energy area where premise is located.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyConsumptionPremisesPremiseIdCustomerSpecificHourlySpotPricesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyConsumptionPremisesPremiseIdCustomerSpecificHourlySpotPricesGet$Response(params: {

    /**
     * The id of the premise
     */
    premiseId: string;

    /**
     * From date expressed in swedish short date string (yyyy-mm-dd).
     */
    fromDate?: string;

    /**
     * To date expressed in swedish short date string (yyyy-mm-dd).
     */
    toDate?: string;
  }): Observable<StrictHttpResponse<Array<MyConsumptionHourlySpotPriceViewModel>>> {

    const rb = new RequestBuilder(this.rootUrl, MyConsumptionElementService.ElementsMyConsumptionPremisesPremiseIdCustomerSpecificHourlySpotPricesGetPath, 'get');
    if (params) {
      rb.path('premiseId', params.premiseId, {});
      rb.query('fromDate', params.fromDate, {});
      rb.query('toDate', params.toDate, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<MyConsumptionHourlySpotPriceViewModel>>;
      })
    );
  }

  /**
   * Get customer specific hourly spot prices for energy area where premise is located.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyConsumptionPremisesPremiseIdCustomerSpecificHourlySpotPricesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyConsumptionPremisesPremiseIdCustomerSpecificHourlySpotPricesGet(params: {

    /**
     * The id of the premise
     */
    premiseId: string;

    /**
     * From date expressed in swedish short date string (yyyy-mm-dd).
     */
    fromDate?: string;

    /**
     * To date expressed in swedish short date string (yyyy-mm-dd).
     */
    toDate?: string;
  }): Observable<Array<MyConsumptionHourlySpotPriceViewModel>> {

    return this.elementsMyConsumptionPremisesPremiseIdCustomerSpecificHourlySpotPricesGet$Response(params).pipe(
      map((r: StrictHttpResponse<Array<MyConsumptionHourlySpotPriceViewModel>>) => r.body as Array<MyConsumptionHourlySpotPriceViewModel>)
    );
  }

  /**
   * Path part for operation elementsMyConsumptionPremisesPremiseIdCostGet
   */
  static readonly ElementsMyConsumptionPremisesPremiseIdCostGetPath = '/elements/my-consumption/premises/{premiseId}/cost';

  /**
   * Get cost for consumption for a premise for a given resolution.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyConsumptionPremisesPremiseIdCostGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyConsumptionPremisesPremiseIdCostGet$Response(params: {

    /**
     * The id of the premise
     */
    premiseId: string;

    /**
     * From date expressed in swedish short date string (yyyy-mm-dd).
     */
    fromDate?: string;

    /**
     * To date expressed in swedish short date string (yyyy-mm-dd).
     */
    toDate?: string;

    /**
     * The resolution of the cost (Yearly, Monthly, Weekly, Daily or Hourly).
     */
    resolution?: string;

    /**
     * Optional parameter for overriding the default version. The parameter should only be used for testing purposes.
     */
    version?: string;
  }): Observable<StrictHttpResponse<Array<MyConsumptionCostViewModel>>> {

    const rb = new RequestBuilder(this.rootUrl, MyConsumptionElementService.ElementsMyConsumptionPremisesPremiseIdCostGetPath, 'get');
    if (params) {
      rb.path('premiseId', params.premiseId, {});
      rb.query('fromDate', params.fromDate, {});
      rb.query('toDate', params.toDate, {});
      rb.query('resolution', params.resolution, {});
      rb.query('version', params.version, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<MyConsumptionCostViewModel>>;
      })
    );
  }

  /**
   * Get cost for consumption for a premise for a given resolution.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyConsumptionPremisesPremiseIdCostGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyConsumptionPremisesPremiseIdCostGet(params: {

    /**
     * The id of the premise
     */
    premiseId: string;

    /**
     * From date expressed in swedish short date string (yyyy-mm-dd).
     */
    fromDate?: string;

    /**
     * To date expressed in swedish short date string (yyyy-mm-dd).
     */
    toDate?: string;

    /**
     * The resolution of the cost (Yearly, Monthly, Weekly, Daily or Hourly).
     */
    resolution?: string;

    /**
     * Optional parameter for overriding the default version. The parameter should only be used for testing purposes.
     */
    version?: string;
  }): Observable<Array<MyConsumptionCostViewModel>> {

    return this.elementsMyConsumptionPremisesPremiseIdCostGet$Response(params).pipe(
      map((r: StrictHttpResponse<Array<MyConsumptionCostViewModel>>) => r.body as Array<MyConsumptionCostViewModel>)
    );
  }

  /**
   * Path part for operation elementsMyConsumptionPremisesPremiseIdTemperatureGet
   */
  static readonly ElementsMyConsumptionPremisesPremiseIdTemperatureGetPath = '/elements/my-consumption/premises/{premiseId}/temperature';

  /**
   * Get temperatures for a premise.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyConsumptionPremisesPremiseIdTemperatureGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyConsumptionPremisesPremiseIdTemperatureGet$Response(params: {

    /**
     * The id of the premise
     */
    premiseId: string;

    /**
     * From date expressed in swedish short date string (yyyy-mm-dd).
     */
    fromDate?: string;

    /**
     * To date expressed in swedish short date string (yyyy-mm-dd).
     */
    toDate?: string;

    /**
     * The resolution of the temperature (Monthly, Weekly, Daily or Hourly)
     */
    resolution?: string;
  }): Observable<StrictHttpResponse<Array<MyConsumptionTemperatureViewModel>>> {

    const rb = new RequestBuilder(this.rootUrl, MyConsumptionElementService.ElementsMyConsumptionPremisesPremiseIdTemperatureGetPath, 'get');
    if (params) {
      rb.path('premiseId', params.premiseId, {});
      rb.query('fromDate', params.fromDate, {});
      rb.query('toDate', params.toDate, {});
      rb.query('resolution', params.resolution, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<MyConsumptionTemperatureViewModel>>;
      })
    );
  }

  /**
   * Get temperatures for a premise.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyConsumptionPremisesPremiseIdTemperatureGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyConsumptionPremisesPremiseIdTemperatureGet(params: {

    /**
     * The id of the premise
     */
    premiseId: string;

    /**
     * From date expressed in swedish short date string (yyyy-mm-dd).
     */
    fromDate?: string;

    /**
     * To date expressed in swedish short date string (yyyy-mm-dd).
     */
    toDate?: string;

    /**
     * The resolution of the temperature (Monthly, Weekly, Daily or Hourly)
     */
    resolution?: string;
  }): Observable<Array<MyConsumptionTemperatureViewModel>> {

    return this.elementsMyConsumptionPremisesPremiseIdTemperatureGet$Response(params).pipe(
      map((r: StrictHttpResponse<Array<MyConsumptionTemperatureViewModel>>) => r.body as Array<MyConsumptionTemperatureViewModel>)
    );
  }

  /**
   * Path part for operation elementsMyConsumptionPremisesPremiseIdHeatWacConsumptionGet
   */
  static readonly ElementsMyConsumptionPremisesPremiseIdHeatWacConsumptionGetPath = '/elements/my-consumption/premises/{premiseId}/heat-wac-consumption';

  /**
   * Get WAC(WeatherAdjustedConsumption-Normalårskorrigerad Förbrukning) Calculation for a premise for a given resolution and consumption type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyConsumptionPremisesPremiseIdHeatWacConsumptionGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyConsumptionPremisesPremiseIdHeatWacConsumptionGet$Response(params: {

    /**
     * The id of the premise
     */
    premiseId: string;

    /**
     * From date expressed in swedish short date string (yyyy-mm-dd).
     */
    fromDate?: string;

    /**
     * To date expressed in swedish short date string (yyyy-mm-dd).
     */
    toDate?: string;

    /**
     * The resolution of the consumption (Monthly). If consumption type is &quot;Energy&quot; and resolution is  Monthly is valid.
     */
    resolution?: string;

    /**
     * The type of consumption (Energy)
     */
    consumptionType?: string;
  }): Observable<StrictHttpResponse<Array<MyConsumptionViewModel>>> {

    const rb = new RequestBuilder(this.rootUrl, MyConsumptionElementService.ElementsMyConsumptionPremisesPremiseIdHeatWacConsumptionGetPath, 'get');
    if (params) {
      rb.path('premiseId', params.premiseId, {});
      rb.query('fromDate', params.fromDate, {});
      rb.query('toDate', params.toDate, {});
      rb.query('resolution', params.resolution, {});
      rb.query('consumptionType', params.consumptionType, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<MyConsumptionViewModel>>;
      })
    );
  }

  /**
   * Get WAC(WeatherAdjustedConsumption-Normalårskorrigerad Förbrukning) Calculation for a premise for a given resolution and consumption type.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyConsumptionPremisesPremiseIdHeatWacConsumptionGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyConsumptionPremisesPremiseIdHeatWacConsumptionGet(params: {

    /**
     * The id of the premise
     */
    premiseId: string;

    /**
     * From date expressed in swedish short date string (yyyy-mm-dd).
     */
    fromDate?: string;

    /**
     * To date expressed in swedish short date string (yyyy-mm-dd).
     */
    toDate?: string;

    /**
     * The resolution of the consumption (Monthly). If consumption type is &quot;Energy&quot; and resolution is  Monthly is valid.
     */
    resolution?: string;

    /**
     * The type of consumption (Energy)
     */
    consumptionType?: string;
  }): Observable<Array<MyConsumptionViewModel>> {

    return this.elementsMyConsumptionPremisesPremiseIdHeatWacConsumptionGet$Response(params).pipe(
      map((r: StrictHttpResponse<Array<MyConsumptionViewModel>>) => r.body as Array<MyConsumptionViewModel>)
    );
  }

  /**
   * Path part for operation elementsMyConsumptionPremisesPremiseIdPowerOfAttorneyGet
   */
  static readonly ElementsMyConsumptionPremisesPremiseIdPowerOfAttorneyGetPath = '/elements/my-consumption/premises/{premiseId}/power-of-attorney';

  /**
   * Get power of attorney status for premise.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyConsumptionPremisesPremiseIdPowerOfAttorneyGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyConsumptionPremisesPremiseIdPowerOfAttorneyGet$Response(params: {

    /**
     * The id of the premise
     */
    premiseId: string;
  }): Observable<StrictHttpResponse<MyConsumptionPowerOfAttorneyStatusViewModel>> {

    const rb = new RequestBuilder(this.rootUrl, MyConsumptionElementService.ElementsMyConsumptionPremisesPremiseIdPowerOfAttorneyGetPath, 'get');
    if (params) {
      rb.path('premiseId', params.premiseId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MyConsumptionPowerOfAttorneyStatusViewModel>;
      })
    );
  }

  /**
   * Get power of attorney status for premise.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyConsumptionPremisesPremiseIdPowerOfAttorneyGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyConsumptionPremisesPremiseIdPowerOfAttorneyGet(params: {

    /**
     * The id of the premise
     */
    premiseId: string;
  }): Observable<MyConsumptionPowerOfAttorneyStatusViewModel> {

    return this.elementsMyConsumptionPremisesPremiseIdPowerOfAttorneyGet$Response(params).pipe(
      map((r: StrictHttpResponse<MyConsumptionPowerOfAttorneyStatusViewModel>) => r.body as MyConsumptionPowerOfAttorneyStatusViewModel)
    );
  }

  /**
   * Path part for operation elementsMyConsumptionPremisesPremiseIdPowerOfAttorneyPut
   */
  static readonly ElementsMyConsumptionPremisesPremiseIdPowerOfAttorneyPutPath = '/elements/my-consumption/premises/{premiseId}/power-of-attorney';

  /**
   * Start power of attorney process for premise.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementsMyConsumptionPremisesPremiseIdPowerOfAttorneyPut()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyConsumptionPremisesPremiseIdPowerOfAttorneyPut$Response(params: {

    /**
     * The id of the premise
     */
    premiseId: string;
  }): Observable<StrictHttpResponse<MyConsumptionPowerOfAttorneyStatusViewModel>> {

    const rb = new RequestBuilder(this.rootUrl, MyConsumptionElementService.ElementsMyConsumptionPremisesPremiseIdPowerOfAttorneyPutPath, 'put');
    if (params) {
      rb.path('premiseId', params.premiseId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MyConsumptionPowerOfAttorneyStatusViewModel>;
      })
    );
  }

  /**
   * Start power of attorney process for premise.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementsMyConsumptionPremisesPremiseIdPowerOfAttorneyPut$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementsMyConsumptionPremisesPremiseIdPowerOfAttorneyPut(params: {

    /**
     * The id of the premise
     */
    premiseId: string;
  }): Observable<MyConsumptionPowerOfAttorneyStatusViewModel> {

    return this.elementsMyConsumptionPremisesPremiseIdPowerOfAttorneyPut$Response(params).pipe(
      map((r: StrictHttpResponse<MyConsumptionPowerOfAttorneyStatusViewModel>) => r.body as MyConsumptionPowerOfAttorneyStatusViewModel)
    );
  }

}
